import { Component, Input} from '@angular/core';
import { IdexService } from 'app/idex.service';

@Component({
   selector: 'app-dms-menu',
   templateUrl: './dms-menu.component.html',
   styleUrls: ['./dms-menu.component.css']
})

export class DmsMenuComponent {
   @Input() business;
   constructor(protected service: IdexService) {
      window.localStorage.removeItem('path_company');
   }

   expand(folders: any) {
      if (!folders.isExpanded()) {
         folders.toggle();
      }
   }
}
